import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Phone } from 'lucide-react';
import PageShell from '@/components/PageShell';
import SEO from '@/components/SEO';
import { useLanguage } from '@/i18n/LanguageContext';
import { FAQ_ITEMS } from '@/data/siteContent';
import { track } from '@/lib/analytics';

const FAQ = () => {
  const { lang, t } = useLanguage();
  const [open, setOpen] = useState(null);

  const toggle = (i) => {
    const next = open === i ? null : i;
    setOpen(next);
    if (next !== null) track('faq_expand', { index: i, question: FAQ_ITEMS[i].en.q });
  };

  return (
    <PageShell trackPage="/faq">
      <SEO
        title="Bail Bond FAQ | Amigo's Bail Bonds | Montgomery County, TX"
        description="Answers to common questions about bail bonds, cost, payment plans, confidentiality, and the Montgomery County Jail process."
        path="/faq"
        jsonLd={{ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: FAQ_ITEMS.map((f) => ({ '@type': 'Question', name: f.en.q, acceptedAnswer: { '@type': 'Answer', text: f.en.a } })) }}
      />
      <div className="page-hero">
        <div className="eyebrow">FAQ</div>
        <h1 className="section-title">{lang === 'es' ? 'PREGUNTAS FRECUENTES' : 'FREQUENTLY ASKED QUESTIONS'}</h1>
      </div>
      <section className="section section--void">
        <div className="container" style={{ maxWidth: 780 }}>
          {FAQ_ITEMS.map((f, i) => (
            <div className="faq-item" key={i}>
              <button className="faq-question" onClick={() => toggle(i)} aria-expanded={open === i} data-testid={`faq-question-${i}`}>
                <span>{f[lang].q}</span>
                <ChevronDown size={18} className="faq-icon" style={{ transform: open === i ? 'rotate(180deg)' : 'none' }} />
              </button>
              {open === i && <div className="faq-answer" data-testid={`faq-answer-${i}`}>{f[lang].a}</div>}
            </div>
          ))}
          <div className="text-center mt-8">
            <div className="flex gap-4" style={{ justifyContent: 'center', flexWrap: 'wrap' }}>
              <a href="tel:9368282500" className="btn-red" data-testid="faq-call-cta"><Phone size={16} /> {t('hero.callNow')}</a>
              <Link to="/start-a-bond" className="btn-brass" data-testid="faq-start-bond-cta">{t('hero.startBond')}</Link>
            </div>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default FAQ;
